<template>
  <div data-qa="card_getting_error">
    <v-img
      width="72"
      height="72"
      class="mx-auto mb-2"
      data-qa="card_getting_error_icon"
      src="/static/_v1/pd/icons/ui-kit/club/club-check-close.svg"
      alt="Иконка ошибки"
    />
    <div
      v-if="componentData.title"
      data-qa="card_getting_error_title"
      class="text-h5 text--text mb-2 text-center"
    >
      {{ componentData.title }}
    </div>
    <div
      v-if="componentData.message"
      data-qa="card_getting_error_message"
      class="text-body-1 text-secondary--text text-center"
    >
      {{ componentData.message }}
    </div>
    <div
      v-if="buttonSubmit || buttonCancel"
      class="mt-4"
    >
      <v-btn
        v-if="buttonSubmit"
        block
        color="primary"
        class="mt-2"
        elevation="0"
        data-qa="card_getting_error_btn_submit"
        @click="$emit(events.club.cardGettingErrorSubmit, buttonSubmit.action)"
      >
        {{ buttonSubmit.text }}
      </v-btn>
      <v-btn
        v-if="buttonCancel"
        text
        block
        color="text"
        class="mt-2"
        elevation="0"
        data-qa="card_getting_error_btn_cancel"
        @click="$emit(events.club.cardGettingErrorCancel, buttonCancel.action)"
      >
        {{ buttonCancel.text }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import {
  eventsData,
  getErrorData,
} from 'www/vue_components/common/Club/components/core/ClubCardGetting/interfaces'

export default {
  name: 'ClubCardGettingError',
  props: {
    componentData: {
      type: Object,
      default: getErrorData,
    },
  },
  data: () => ({
    events: eventsData,
  }),
  computed: {
    buttonSubmit() {
      return this.componentData.buttonState.submit
    },
    buttonCancel() {
      return this.componentData.buttonState.cancel
    },
  },
}
</script>
